import { useMemo } from 'react'
import { aDrawnFeature, aMapViewState, useAtomValue } from '~/atoms'
import {
  appMapBoundsToGeoWithinPolygon,
  simplifyDrawPolygonFeature,
} from '~/components'

export default function useSearchLocation() {
  const mapViewState = useAtomValue(aMapViewState)
  const drawnFeature = useAtomValue(aDrawnFeature)
  const mapDrawnFeature = useMemo(
    () => simplifyDrawPolygonFeature(drawnFeature),
    [drawnFeature]
  )

  return useMemo(() => {
    if (mapDrawnFeature) {
      const isCircle = mapDrawnFeature.properties?.isCircle ? 'true' : 'false'

      return {
        $geoWithin: {
          $geometry: {
            ...mapDrawnFeature.geometry,
            properties: {
              ...mapDrawnFeature.properties,
              isCircle,
            },
          },
        },
      }
    } else if (mapViewState) {
      return {
        $geoWithin: {
          $geometry: appMapBoundsToGeoWithinPolygon(mapViewState.bounds),
        },
      }
    }

    return {}
  }, [mapDrawnFeature, mapViewState])
}
